/**
 * DELETE a repeatable-section unit, treating 404 as success (#1453).
 *
 * A unit referenced by an edit session can already be gone server-side: a scope
 * removal clears the whole family's rows transactionally, but a session that
 * still held the unit (stale baseline, restored draft snapshot, second tab)
 * would DELETE it again on the next Save and fail the entire save with
 * "… configuration not found for this request". The row being absent is the
 * exact end state the DELETE wanted, so 404 is a success; every other error
 * still fails the flush.
 */
import { api, ApiError } from './api';

export async function deleteRepeatableUnitTolerating404(
  path: string,
): Promise<void> {
  try {
    await api.delete(path);
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      return;
    }
    throw error;
  }
}
